// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__fzMZy","errorLogs":"EditorFooter_errorLogs__1smKR"};